// Function to extract Facebook username from a URL
function extractFacebookUsername(url) {
    if (!url) {
        return {
            return_string: '',
            error: 'URL is null or undefined'
        };
    }
    const regex = /facebook\.com\/([^?\/]+)/;
    const match = url.match(regex);
    const final_val = match ? match[1] : url;
    const validUsernameRegex = /^[a-zA-Z0-9._-]+$/;
    const isValid = validUsernameRegex.test(final_val);
    return {
        return_string: final_val,
        error: isValid ? '' : 'not a valid Facebook username'
    };
}

// Function to extract Instagram username from a URL
function extractInstagramUsername(url) {
    if (!url) {
        return {
            return_string: '',
            error: 'URL is null or undefined'
        };
    }
    const regex = /instagram\.com\/([^?\/]+)/;
    const match = url.match(regex);
    const final_val = match ? match[1] : url;
    const validUsernameRegex = /^[a-zA-Z0-9._-]+$/;
    const isValid = validUsernameRegex.test(final_val);
    return {
        return_string: final_val,
        error: isValid ? '' : 'not a valid Instagram username'
    };
}

// Function to extract TikTok username from a URL
function extractTikTokUsername(url) {
    if (!url) {
        return {
            return_string: '',
            error: 'URL is null or undefined'
        };
    }
    const regex = /tiktok\.com\/@([^?\/]+)/;
    const match = url.match(regex);
    const final_val = match ? match[1] : url;
    const validUsernameRegex = /^[a-zA-Z0-9._-]+$/;
    const isValid = validUsernameRegex.test(final_val);
    return {
        return_string: final_val,
        error: isValid ? '' : 'not a valid TikTok username'
    };
}

// Function to extract LinkedIn profile ID from a URL
function extractLinkedInProfile(url) {
    if (!url) {
        return {
            return_string: '',
            error: 'URL is null or undefined'
        };
    }
    const regex = /linkedin\.com\/in\/([^?\/]+)/;
    const match = url.match(regex);
    const final_val = match ? match[1] : url;
    const validUsernameRegex = /^[a-zA-Z0-9-]+$/;
    const isValid = validUsernameRegex.test(final_val);
    return {
        return_string: final_val,
        error: isValid ? '' : 'not a valid LinkedIn profile ID'
    };
}

// Function to extract WhatsApp phone number from a URL
function extractWhatsAppNumber(url) {
    if (!url) {
        return {
            return_string: '',
            error: 'URL is null or undefined'
        };
    }
    const regex = /wa\.me\/(\d+)/;
    const match = url.match(regex);
    const final_val = match ? match[1] : url;
    const isValid = /^[0-9]+$/.test(final_val);
    return {
        return_string: final_val,
        error: isValid ? '' : 'not a valid WhatsApp number'
    };
}

// Function to extract Twitter username from a URL
function extractTwitterUsername(url) {
    if (!url) {
        return {
            return_string: '',
            error: 'URL is null or undefined'
        };
    }
    const regex = /twitter\.com\/([^?\/]+)/;
    const match = url.match(regex);
    const final_val = match ? match[1] : url;
    const validUsernameRegex = /^[a-zA-Z0-9_]+$/;
    const isValid = validUsernameRegex.test(final_val);
    return {
        return_string: final_val,
        error: isValid ? '' : 'not a valid Twitter username'
    };
}

// Function to extract Yelp business ID from a URL
function extractYelpBusinessID(url) {
    if (!url) {
        return {
            return_string: '',
            error: 'URL is null or undefined'
        };
    }
    const regex = /yelp\.com\/biz\/([^?\/]+)/;
    const match = url.match(regex);
    const final_val = match ? match[1] : url;
    const validUsernameRegex = /^[a-zA-Z0-9-]+$/;
    const isValid = validUsernameRegex.test(final_val);
    return {
        return_string: final_val,
        error: isValid ? '' : 'not a valid Yelp business ID'
    };
}

// Function to extract Google Reviews place ID from a URL
function extractGoogleReviewsPlaceID(url) {
    if (!url) {
        return {
            return_string: '',
            error: 'URL is null or undefined'
        };
    }
    const regex = /google\.com\/maps\/place\/([^?\/]+)/;
    const match = url.match(regex);
    const final_val = match ? match[1] : url;
    const validUsernameRegex = /^[a-zA-Z0-9-._]+$/;
    const isValid = validUsernameRegex.test(final_val);
    return {
        return_string: final_val,
        error: isValid ? '' : 'not a valid Google Reviews place ID'
    };
}

// Export the function to be used in other files
module.exports = {
    extractFacebookUsername,
    extractInstagramUsername,
    extractTikTokUsername,
    extractLinkedInProfile,
    extractWhatsAppNumber,
    extractTwitterUsername,
    extractYelpBusinessID,
    extractGoogleReviewsPlaceID
};
